/**
 * Issue #1317 (Pick XI coach 2 of 3; D253) — one of the three tags on a
 * batting-order row: Captain (C), Vice-captain (VC) or Keeper (WK). A small
 * text switch, 52 by 44 minimum, as drawn in `PickTheXI.dc.html`
 * (`xi-tag-c-1`: radius 10, 14px/700, on = filled). `role="switch"` and
 * `aria-checked` carry the state, so G1 does not count it as a place to go.
 * It lives here and not in the kit: the kit's `ToggleSwitch` is a pill.
 *
 * On: C is navy with white text, VC is the navy tint with a navy border, WK
 * is the OK green with white text, as the legend on the board draws them.
 */
const ON = {
  c: { background: "var(--nw-navy)", color: "#FFFFFF", borderColor: "var(--nw-navy)" },
  vc: { background: "var(--nw-navy-tint)", color: "var(--nw-navy)", borderColor: "var(--nw-navy)" },
  wk: { background: "var(--nw-ok)", color: "#FFFFFF", borderColor: "var(--nw-ok)" },
};
const OFF = { background: "var(--nw-surface)", color: "var(--nw-ink-lede)", borderColor: "var(--nw-line-strong)" };

export default function TagSwitch({ kind, text, label, on, onToggle, "data-testid": testId }) {
  const tone = on ? ON[kind] : OFF;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      data-testid={testId}
      data-nav="in-place"
      onClick={onToggle}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 52,
        minHeight: 44,
        boxSizing: "border-box",
        padding: "0 10px",
        borderRadius: "var(--nw-radius-control)",
        border: "1px solid",
        fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
        fontSize: 14,
        fontWeight: 700,
        cursor: "pointer",
        ...tone,
      }}
    >
      {text}
    </button>
  );
}
